import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { SegmentContext } from '@/components/Segment';
import ButtonBase from '@/components/ButtonBase';
import useStyle from './style';
import cx from '@/utils/cx';

const SegmentItem = ({
  children,
  content,
  className,
  ...rest
}) => {
  const {
    hashedValue,
    onChange,
    color,
    type,
  } = useContext(SegmentContext);
  const classes = useStyle({ color, type });
  const hashedContent = useMemo(() => JSON.stringify(content), [content]);
  const isSelected = hashedContent === hashedValue;

  return (
    <ButtonBase
      size="sm"
      fullWidth
      className={cx(classes.segmentItem, isSelected && 'selected', className)}
      onClick={() => onChange(content)}
      {...rest}
    >
      {children}
    </ButtonBase>
  );
};

SegmentItem.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.any.isRequired,
};

export default SegmentItem;
